module.exports = __webpack_public_path__ + "static/media/im_5.29ea0846.JPG";